import {
  HiOutlineArchiveBox,
  HiOutlineBriefcase,
  HiOutlineCheckCircle,
  HiOutlineFolder,
  HiOutlineUserGroup,
  HiOutlineUsers,
} from "react-icons/hi2";

import DashboardCard from "./DashboardCard";

import "./DashboardStats.css";

export default function DashboardStats({ type, stats = {} }) {
  if (type === "admin") {
    return (
      <div className="dashboard-stats">
        <DashboardCard
          icon={<HiOutlineUsers />}
          label="Jongeren"
          value={stats.total_clients}
        />

        <DashboardCard
          icon={<HiOutlineFolder />}
          label="Trajecten"
          value={stats.total_dossiers}
        />

        <DashboardCard
          icon={<HiOutlineBriefcase />}
          label="Actieve trajecten"
          value={stats.active_dossiers}
        />

        <DashboardCard
          icon={<HiOutlineArchiveBox />}
          label="Gearchiveerd"
          value={stats.archived_dossiers}
        />

        <DashboardCard
          icon={<HiOutlineUserGroup />}
          label="Coaches"
          value={stats.total_coaches}
        />
      </div>
    );
  }

  return (
    <div className="dashboard-stats">
      <DashboardCard
        icon={<HiOutlineFolder />}
        label="Mijn dossiers"
        value={stats.my_dossiers}
      />

      <DashboardCard
        icon={<HiOutlineBriefcase />}
        label="Actief"
        value={stats.active_dossiers}
      />

      <DashboardCard
        icon={<HiOutlineCheckCircle />}
        label="Afgerond"
        value={stats.completed_dossiers}
      />

      <DashboardCard
        icon={<HiOutlineArchiveBox />}
        label="Gepauzeerd"
        value={stats.paused_dossiers}
      />
    </div>
  );
}
